import { defineMessages } from 'react-intl';

export default defineMessages({
    policyDetailsTitle: {
        id: 'twia.gateway.contacts.policyroles.Name',
        defaultMessage: 'Name',
    },
    policyDetailsTitle: {
        id: 'twia.gateway.contacts.policyroles.FirstName',
        defaultMessage: 'First Name',
    },
    policyDetailsTitle: {
        id: 'twia.gateway.contacts.policyroles.LastName',
        defaultMessage: 'Last Name',
    },
    changeButton: {
        id: 'twia.gateway.contacts.Change',
        defaultMessage: 'Change',
    },
    cancelButton: {
        id: 'twia.gateway.contacts.Cancel',
        defaultMessage: 'Cancel',
    },
    required: {
        id: 'twia.gateway.contacts.This is a required field.',
        defaultMessage: 'This is a required field.'
    }
})